import { GetQueryString } from "../../../../../src/demos/get-querystring.tsx";
import * as React from 'react';
export default {
  GetQueryString,
  React
};